export default function convertToCustomProperty(value, fallback) {
  return `var(--${value.replace(/(\d+|[A-Z])/g, '-$1').toLowerCase()}, ${fallback || value})`;
}
